<template>
  <main class="report_popup">
    <div class="modal_wrap bottom_modal" :class="{ on: show }">
      <div class="modal_inner" @click.self="$emit('closeReportPopup')">
        <div class="modal">
          <div class="report_list" @click.self="$emit('openReportModal')">
            리뷰 신고하기
          </div>
          <div class="report_list" @click.self="$emit('openReportUserModal')">
            사용자 신고하기
          </div>
          <div class="report_close" @click="reportClose">닫기</div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
} from '@common/lib/common/utils';

import {
  mapActions as reviewMapActions,
  mapGetters as reviewMapGetters,
} from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';
import { sleep, nativeDeviceInfo } from '@common/lib/common/utils';
import Vue from 'vue';
export default {
  name: 'reportPopup',
  props: {
    show: Boolean,
  },
  components: {},
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    // ...chatMapGetters({
    //   chatroom_with: chatGetters.CHATROOMS_WITH,
    // }),
  },
  mounted() {},
  methods: {
    // ...commonMapActions([
    //   commonActions.SET_DIALOG,
    //   commonActions.HIDE_DIALOG,
    //   commonActions.SET_SNACKBAR,
    // ]),
    reportClose() {
      this.$emit('closeReportPopup');
    },
  },
};
</script>
